module.exports = "/img/why.0b2466b3.png";